import { debugModeOn } from "./app";
/**
 * Renders given component
 *
 * @param Element
 */
export default function render(Element) {
    const kompo = Element.kompo;
    if (!kompo.initial)
        return;
    if (debugModeOn() && kompo.debug) {
        console.groupCollapsed('RENDER: ');
        console.log(Element);
        console.log(kompo);
        console.groupCollapsed('CONSTRUCT: ');
    }
    // Construct then ...
    Element.construct(kompo.props);
    kompo.initial = false;
    if (debugModeOn() && kompo.debug) {
        console.groupEnd();
    }
    // ... react
    const statefulls = kompo.statefulls, selector = kompo.selector, state = selector ? selector(Element.__kompo__.state) : Element.__kompo__.state;
    if (statefulls.length > 0 && state) {
        if (debugModeOn() && kompo.debug) {
            console.log('HAS STATE: ', state);
            console.groupCollapsed('REACTS: ');
        }
        for (let i = 0, l = statefulls.length; i < l; ++i) {
            statefulls[i](state, Element);
        }
        if (debugModeOn() && kompo.debug) {
            console.groupEnd();
        }
    }
    if (debugModeOn() && kompo.debug) {
        console.groupEnd();
    }
}
//# sourceMappingURL=render.js.map


//////////////////
// WEBPACK FOOTER
// ./~/kompo/lib/component/render.js
// module id = 4
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11